import { PayloadAction } from '@reduxjs/toolkit'
import { ICreditsState, ICredit } from 'store/types/credit'

const reducers = {
  setFeatureOperationCosts: (
    state: ICreditsState,
    action: PayloadAction<ICredit[]>
  ) => {
    state.featureOperationCosts = action.payload
  },
  setUserCredits: (state: ICreditsState, action: PayloadAction<number>) => {
    state.userCredits = action.payload
  }
}

export default reducers
